import { Info } from "lucide-react";
import Reveal from "@/components/Reveal";
import { FINANCIAL_DISCLAIMER } from "@/config/site";

export const Disclaimer = () => (
  <section className="relative py-6">
    <div className="container-nova">
      <Reveal>
        <div className="flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.02] p-6" data-testid="financial-disclaimer">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-nova-cyan">
            <Info size={18} />
          </div>
          <div>
            <p className="text-sm font-semibold text-white">Important</p>
            <p className="mt-1.5 text-sm leading-relaxed text-white/55">{FINANCIAL_DISCLAIMER}</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Disclaimer;
